import React, { ChangeEvent, useState } from 'react';
import { TbMessage, TbMessage2Plus, TbMessage2Question, TbTrash } from 'react-icons/tb';
import Modal from '../Modal';
import ButtonPrimary from '../../Form/ButtonPrimary';
import Button from '../../Form/Button';
import { useTranslation } from 'react-i18next';

interface AddProductObservationProps {
    observation: string;
    onHandleObservation: CallableFunction;
}

const AddProductObservation = ({
    observation,
    onHandleObservation
}: AddProductObservationProps) => {

    const { t } = useTranslation();
    const [newObservation, setNewObservation] = useState<any>('');
    const [showEditObservation, setShowEditObservation] = useState<boolean>(false);

    const handleNewObservation = (event: ChangeEvent<HTMLTextAreaElement>) => {
        setNewObservation(event.target.value);
    };

    const handleConfirm = () => {
        onHandleObservation(newObservation);
        setShowEditObservation(false);
    };

    const handleDelete = () => {
        onHandleObservation('');
        setNewObservation('');
        setShowEditObservation(false);
    };

    return (
        <>
            <div className="flex flex-col gap-1 w-full cursor-pointer" onClick={() => setShowEditObservation(true)}>
                <h4 className='flex items-center gap-0.5 font-medium text-sm text-shopfood-title'>
                    <div className={`flex gap-0.5 items-center text-sm mt-0.5 font-medium ${!observation && 'text-shopfood-info'}`}>
                        <span className='inline-flex gap-0.5 leading-4'>
                            <span className='mt-[1px]'>{observation ? <TbMessage className='text-shopfood-info' /> : <TbMessage2Plus />}</span>
                            <span className={`text-left ${observation && 'italic'}`}>{observation ? observation : t('layout.observation.link')}</span>
                        </span>
                    </div>
                </h4>
            </div>

            <Modal open={showEditObservation} className="max-w-sm m-4" onClose={() => setShowEditObservation(false)}>

                <section className='flex flex-col items-center w-full p-6 gap-6'>
                    <h4 className='flex flex-col items-center'>
                        <span className='mb-2 text-shopfood-title'><TbMessage2Question size={45} /></span>
                        <span className='font-bold text-xl text-shopfood-title'>{t('layout.observation.title')}</span>
                    </h4>

                    <textarea
                        name="observation"
                        className={`
                        block w-full rounded-md leading-5 border-0 p-2.5 shadow ring-1 ring-gray-300 placeholder:text-gray-300
                        focus:ring-2 focus:ring-custom-primary
                        transition-all ease-in-out duration-500
                        h-24 focus:h-24
                        `}
                        placeholder={t('layout.observation.placeholder')}
                        defaultValue={observation}
                        onChange={(event) => handleNewObservation(event) }
                    />
                    <div className='flex justify-center gap-2 w-full'>
                        <ButtonPrimary disabled={observation === newObservation} onClick={handleConfirm} className='w-full'>
                            {observation ? t('layout.observation.button_submit.edit') : t('layout.observation.button_submit.add')}
                        </ButtonPrimary>
                        <Button onClick={() => setShowEditObservation(false)}>{t('layout.confirm.cancel')}</Button>
                        {observation && <Button rounded onClick={handleDelete} disabled={Boolean(!observation)}><div><TbTrash /></div></Button>}
                    </div>
                </section>

            </Modal>
        </>
    )
}

export default AddProductObservation;
